export function NetworkStation() {
  return (
    <section className="foundry-network-station" aria-labelledby="foundry-network-title">
      <svg viewBox="0 0 1200 250" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0 70H210L270 125H520L585 64H760L820 125H1200" pathLength="100" />
        <path d="M0 196H300L350 145H660L720 205H960L1020 145H1200" pathLength="100" />
      </svg>
      <div>
        <p>SMACKERS TOWER · CARRIER ONLINE</p>
        <h2 id="foundry-network-title">Enter the AIMEE world from Fighter Foundry.</h2>
        <span>The world opens aligned to this tower. Break away from the site face, then fly the full station network.</span>
      </div>
      <nav aria-label="Fighter Foundry station links">
        <a className="foundry-world-link" href="https://l34d.ca/?world=1&station=smackers">Enter AIMEE World <b>360°</b></a>
        <a href="https://l34d.ca">L34D Hub</a>
        <a href="https://aimee.l34d.ca">AIMEE</a>
        <a href="https://demovault.l34d.ca">DemoVault</a>
      </nav>
    </section>
  );
}
